// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"532":"styles","570":"36bcf0ca","678":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"231":"74249bb6a55c0342dbce","532":"b121ec4370381d9b2118","570":"b79010164daa7ed039f7","610":"1abaa5d4124a6b7f39c6","678":"a7389f0925f890d8b8e1","898":"118d8d0518599c1afa4f"}[chunkId] + ".js";
};